// ANCHOR Base
import { RadioGroup, Radio, ALIGN } from 'baseui/radio';

// ANCHOR Models
import { useFormQuestionAnswersForStudentData } from '@lyon/scoped-models/form/FormQuestionAnswersDataForStudent';
import {
  useFormSubmissionQuestionItemAnswer,
} from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { LyonViewAnswerFormQuestionStatusIcon } from '../../LyonViewAnswerFormQuestionStatusIcon';

// ANCHOR Styles
import { RADIO_GROUP, RADIO } from './styles';

export const LyonViewAnswerFormMultipleChoice = constant(() => {
  const choices = useFormQuestionAnswersForStudentData();
  const userAnswers = useFormSubmissionQuestionItemAnswer();

  if (!choices) {
    return <Loader />;
  }

  if (choices.length === 0) {
    return null;
  }

  return (
    <RadioGroup
      value={userAnswers.join(', ')}
      align={ALIGN.vertical}
      overrides={RADIO_GROUP}
    >
      {
        choices.map(({ name }) => (
          <Radio
            value={name}
            key={name}
            overrides={RADIO}
          >
            {name}
            {name === userAnswers.join(', ') && <LyonViewAnswerFormQuestionStatusIcon />}
          </Radio>
        ))
      }
    </RadioGroup>
  );
});
